export default "__VITE_ASSET__0DkrPsQe__"